import { useEffect } from 'react';

const TONE_STYLES = {
  success: { bg: 'var(--ab-approved-soft)', fg: 'var(--ab-approved)', border: 'var(--ab-approved)' },
  error:   { bg: 'var(--ab-denied-soft)',   fg: 'var(--ab-denied)',   border: 'var(--ab-denied)' },
  warning: { bg: 'var(--ab-pending-soft)',  fg: 'var(--ab-pending)',  border: 'var(--ab-pending-ring)' },
  info:    { bg: 'var(--ab-info-soft)',     fg: 'var(--ab-info)',     border: 'var(--ab-info)' },
};

/**
 * @param {{ toast: { severity: 'success'|'error'|'warning'|'info', message: string } | null, onClose: () => void, durationMs?: number }} props
 */
export default function Toast({ toast, onClose, durationMs = 5000 }) {
  useEffect(() => {
    if (!toast) return undefined;
    const id = setTimeout(onClose, durationMs);
    return () => clearTimeout(id);
  }, [toast, onClose, durationMs]);

  if (!toast) return null;
  const t = TONE_STYLES[toast.severity] || TONE_STYLES.info;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
        background: t.bg, color: t.fg, border: `1px solid ${t.border}`,
        borderRadius: 'var(--ab-radius-sm)',
        padding: '10px 16px', zIndex: 1100,
        fontSize: 'var(--ab-text-sm)',
        boxShadow: 'var(--ab-shadow-md)',
        maxWidth: 480,
      }}
    >
      {toast.message}
    </div>
  );
}
